var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack244({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.1,7.88,6.22,7.2c.28-.32.57-.62.87-.91l.23-.23c-.09,0-.37-.08-.83-.19a5.91,5.91,0,0,1-.66-.18l.34-1a9.34,9.34,0,0,1,1.38.68,10.11,10.11,0,0,1-.14-1.55h1a13.13,13.13,0,0,1-.16,1.57l.5-.23c.36-.16.68-.3,1-.41l.31,1.06c-.44.1-.94.19-1.51.28l.7.8c.15.16.26.29.34.39l-.9.59L7.92,6.53C7.68,7,7.41,7.4,7.1,7.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack244);
export default __webpack_public_path__ + "static/media/Symbolpack_2_44.9345c264faa8c207e3e10a17062f8b45.svg";
export { ForwardRef as ReactComponent };